/**
 * Lumistelle Carousel Initialization
 * Version 3.1 - Fixed Multiple Instance Support
 */
console.log('[LumistelleCarousel] Init file loaded');

(function(window, document) {
  'use strict';

  // Only execute if the engine is loaded and the init script hasn't run
  if (!window.LumistelleCarouselEngine || window.Lumistelle) {
    return;
  }

  // 1. Create the singleton engine instance
  const engine = new window.LumistelleCarouselEngine();

  // 2. Expose a global, namespaced API
  window.Lumistelle = {
    engine: engine,
    // This is the function that our Liquid template will call
    initLumistelleSection: function(element) {
      if (element && !element.hasAttribute('data-initialized')) {
        element.setAttribute('data-initialized', 'true');
        
        let config = {};
        const configEl = element.querySelector('[data-config]') || element;
        try {
          if (configEl.dataset.config) {
            config = JSON.parse(configEl.dataset.config);
          }
        } catch (e) {
          console.error('[Lumistelle] Failed to parse config:', e);
        }
        
        this.engine.createInstance(element, config);
      }
    },
    
    // Initialize all pending carousels
    initializePendingCarousels: function() {
      if (window.lumistellePendingInit && window.lumistellePendingInit.length > 0) {
        const pendingIds = [...window.lumistellePendingInit];
        
        pendingIds.forEach(sectionId => {
          const element = document.getElementById(sectionId);
          if (element && !element.hasAttribute('data-initialized')) {
            this.initLumistelleSection(element);
          }
        });
        
        window.lumistellePendingInit = window.lumistellePendingInit.filter(
          id => !document.getElementById(id)?.hasAttribute('data-initialized')
        );
      }
    }
  };

  // 3. Initialize any carousels that were waiting
  window.Lumistelle.initializePendingCarousels();

  // 4. Dispatch a custom event to let the page know the engine is ready
  document.dispatchEvent(new CustomEvent('lumistelle:engine:ready'));
  
  // 5. After dispatching, try one more time to catch any stragglers
  setTimeout(() => {
    window.Lumistelle.initializePendingCarousels();
  }, 100);

})(window, document);